export default __webpack_public_path__ + "static/develop-your-town-41690528bca545f5daa26b530959d38e.jpg";